module.exports = __webpack_public_path__ + "media/assets/images/logo_banco_votorantim-99c56947eec40ca8e5f1819aa9621eea.png";